module.exports = __webpack_public_path__ + "img/havanna_oak_602m_list.06b3b426.jpg";